/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListLockRuleModel {
    getFixupPrototypeFunction() { return ListLockRuleModel.fixupPrototype; }

    static newInstance(model: Partial<ListLockRuleModel>): ListLockRuleModel {
        let obj = Object.assign(new ListLockRuleModel(), model);
        ListLockRuleModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListLockRuleModel>): ListLockRuleModel {
        if (!model) return null;
        return ListLockRuleModel.newInstance(<ListLockRuleModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListLockRuleModel) {
        if (!obj) return;

        models.ListLockRuleModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListLockRuleModel): boolean {
        Object.setPrototypeOf(obj, ListLockRuleModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.applicability_by) {
            models.FilterData.fixupPrototype(this.applicability_by);
        }
    }

    /**
     * cloud_account_name
     */
    tenant_name: string;

    /**
     * cloud_account_name
     */
    tenant_id: string;

    /**
     * cloud_acccount_id
     */
    cloud_account_id: string;

    /**
     * cloud_account_name
     */
    cloud_account_name: string;

    /**
     * cloud name
     */
    cloud: string;

    /**
     * filters for cloud _account_scope
     */
    applicability_by: models.FilterData;

    /**
     * lock type
     */
    lock_type: string;

    /**
     * cloud_acccount_id
     */
    config_rule_id: string;

    /**
     * Flag to identify config rule is active or not
     */
    is_active: boolean;

}
